import { Injectable, Inject } from '@angular/core';
// import * as auth0 from 'auth0-js';

// import createAuth0Client, { GetTokenSilentlyVerboseResponse } from '@auth0/auth0-spa-js';
import {
  GetTokenSilentlyVerboseResponse,
  createAuth0Client,
} from '@auth0/auth0-spa-js';
// import Auth0Client from '@auth0/auth0-spa-js/dist/typings/Auth0Client';
import { Auth0Client } from '@auth0/auth0-spa-js';
import {
  from,
  of,
  Observable,
  BehaviorSubject,
  combineLatest,
  throwError,
} from 'rxjs';
import {
  tap,
  catchError,
  concatMap,
  shareReplay,
  filter,
} from 'rxjs/operators';

import { Router } from '@angular/router';

import { ConfigService } from './config.service';
import  moment from 'moment';
import { Environment } from '../model/environment';
import { now } from 'moment';
// import { createConfig } from '@ngrx/store-devtools/src/instrument';

(window as any).global = window;

interface UserProfile {
  given_name?: string;
  family_name?: string;
  nickname?: string;
  email?: string;
  [key: string]: unknown;
}

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  userProfile: any;

  // Create an observable of Auth0 instance of client
  auth0Client$ = (
    from(
      createAuth0Client({
        domain: this.config.auth.domain,
        clientId: this.config.auth.clientID,
        authorizationParams: {
          redirect_uri: `${window.location.origin}/callback`,
          audience: this.config.auth.audience,
        },
      })
    ) as Observable<Auth0Client>
  ).pipe(
    shareReplay(1), // Every subscription receives the same shared value
    catchError((err) => throwError(err))
  );
  // Define observables for SDK methods that return promises by default
  // For each Auth0 SDK method, first ensure the client instance is ready
  // concatMap: Using the client instance, call SDK method; SDK returns a promise
  // from: Convert that resulting promise into an observable
  isAuthenticated$ = this.auth0Client$.pipe(
    concatMap((client: Auth0Client) => from(client.isAuthenticated())),
    tap((res) => (this.loggedIn = res))
  );
  handleRedirectCallback$ = this.auth0Client$.pipe(
    concatMap((client: Auth0Client) => from(client.handleRedirectCallback()))
  );
  // Create subject and public observable of user profile data
  private userProfileSubject$ = new BehaviorSubject<any>(null);
  userProfile$ = this.userProfileSubject$.asObservable();
  // Create a local property for login status
  loggedIn: any = null;

  // tslint:disable-next-line:variable-name
  public _lastActive$ = new BehaviorSubject<any>(null);
  // tslint:disable-next-line:variable-name
  public _expiresAt$ = new BehaviorSubject<any>(null);
  // tslint:disable-next-line:variable-name
  public _loginTime: number | undefined;
  // tslint:disable-next-line:variable-name
  private _lastActive = 0;
  // tslint:disable-next-line:variable-name
  private _expiresAt: number | undefined;

  get lastActive(): number {
    return this._lastActive;
  }

  public setLastActive(): void {
    this._lastActive = Date.now();
    this._lastActive$.next(this._lastActive);
    if (this.config.debug) {
      console.log(
        'set lastActive: ' +
          moment(this._lastActive).format('DD-MM-YYYY hh:mm:ss')
      );
    }
  }

  get expiresAt(): number | undefined {
    return this._expiresAt;
  }
  public setExpiresAt(): void {
    this._expiresAt =
      this._lastActive + this.config.MINUTES_UNITL_AUTO_LOGOUT * 60 * 1000;
    this._expiresAt$.next(this._expiresAt);
  }

  constructor(
    @Inject(ConfigService) private config: Environment,
    private router: Router
  ) {
    // On initial load, check authentication state with authorization server
    // Set up local auth streams if user is already authenticated
    this.localAuthSetup();

    // Handle redirect from Auth0 login
    // this.handleAuthCallback();
  }

  // When calling, options can be passed if desired
  // https://auth0.github.io/auth0-spa-js/classes/auth0client.html#getuser
  getUser$(): Observable<UserProfile> {
    return this.auth0Client$.pipe(
      concatMap((client: Auth0Client) => from(client.getUser())),
      tap((user) => {
        if (!user) {
          console.warn('getUser$: Received null user from Auth0'); // 06/02/2025 TK
        }
      }),
      filter((user): user is UserProfile => user != null),
      tap((user) => {
        this.userProfileSubject$.next(user);
        console.log('getUser$: userProfile:');
        console.log(user);
        this.userProfile = user;
      })
    );
  }

  // When calling, options can be passed if desired
  // https://auth0.github.io/auth0-spa-js/classes/auth0client.html#gettokensilently
  getTokenSilently$(
    options?: any
  ): Observable<GetTokenSilentlyVerboseResponse> {
    return this.auth0Client$.pipe(
      // tap((cliStore: Auth0Client) => {
      //   console.log('cliStore');
      //   const a = JSON.parse(JSON.stringify(cliStore));
      //   console.log(a);
      //   //this._expiresAt =         authResult.expiresIn * 1000 + Date.now();
      // }),
      concatMap((client: Auth0Client) => from(client.getTokenSilently(options)))
    );
  }

  public userHasScopes(scopes: Array<string>): boolean {
    console.log(`userHasScopes: ${scopes}`);
    console.log(`userProfile:`);
    console.log(this.userProfile);
    let permissions = '';

    const namespace = 'http://softsplice/claims/';
    if (this.userProfile !== undefined) {
      permissions = this.userProfile[namespace + 'permissions'];
    } else {
      return false;
    }
    // console.log('permissions');
    // console.log(permissions);
    if (permissions !== '') {
      return scopes.every((scope) => permissions.includes(scope));
    } else {
      return false;
    }

    // return true;
    // return scopes.every(scope => grantedScopes.includes(scope));
  }

  /**
   * Extracts the user ID from the userProfile sub field
   * @returns The user ID (number after auth0|) or null if not available
   */
  public getUserId(): string | null {
    if (!this.userProfile || !this.userProfile.sub) {
      return null;
    }

    const sub = this.userProfile.sub as string;
    const parts = sub.split('|');

    if (parts.length === 2 && parts[0] === 'auth0') {
      return parts[1]; // Return the user ID part
    }

    return null;
  }

  localAuthSetup(): void {
    this.setLastActive();
    // This should only be called on app initialization
    // Set up local authentication streams
    const checkAuth$ = this.isAuthenticated$.pipe(
      concatMap((loggedIn: boolean) => {
        if (loggedIn) {
          // If authenticated, get user and set in app
          // NOTE: you could pass options here if needed
          return this.getUser$();
        }
        // If not authenticated, return stream that emits 'false'
        return of(loggedIn);
      })
    );
    checkAuth$.subscribe((response: { [key: string]: any } | boolean) => {
      // If authenticated, response will be user object
      // If not authenticated, response will be 'false'
      this.loggedIn = !!response;
    });
  }

  login(redirectPath = '/dashboards/dashboard1'): void {
    console.log('login');
    // A desired redirect path can be passed to login method
    // (e.g., from a route guard)
    // Ensure Auth0 client instance exists
    this.auth0Client$.subscribe((client: Auth0Client) => {
      // Call method to log in
      client.loginWithRedirect({
        authorizationParams: {
          redirect_uri: `${window.location.origin}/callback`,
        },
        appState: { target: redirectPath },
      });
    });
  }

  handleAuthCallback(): void {
    console.log('handleAuthCallback');
    this._loginTime = now();
    // Only the callback component should call this method
    // Call when app reloads after user logs in with Auth0
    let targetRoute: string; // Path to redirect to after login processsed
    const authComplete$ = this.handleRedirectCallback$.pipe(
      // Have client, now call method to handle auth callback redirect
      tap((cbRes) => {
        // Get and set target redirect route from callback results
        console.log('cbRes:');
        console.log(cbRes);
        targetRoute =
          cbRes.appState && cbRes.appState.target
            ? cbRes.appState.target
            : '/dashboards/dashboard1';
      }),
      concatMap(() => {
        // Redirect callback complete; get user and login status
        return combineLatest([this.getUser$(), this.isAuthenticated$]);
      })
    );
    // Subscribe to authentication completion observable
    // Response will be an array of user and login status
    authComplete$.subscribe(([user, loggedIn]) => {
      // Redirect to target route after callback processing
      console.log(`targetRoute ${targetRoute}`);
      this.router.navigate([targetRoute]);
    });
  }

  logout(): void {
    // Ensure Auth0 client instance exists
    console.log('logout');
    this.auth0Client$.subscribe((client: Auth0Client) => {
      // Call method to log out
      client.logout({
        clientId: this.config.auth.clientID,
        logoutParams: {
          returnTo: window.location.origin,
        },
      });
    });
  }
}
